import { css } from '@emotion/react';
import { Animation, Colors, Icon, Link, Typography, } from '@zapier/design-system';
import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';
import { useUniversalNavContext } from '../../../hooks';
const Styles = labelStyles('UniversalSidebarSubmenu', {
    summary: [
        css `
      display: block;
      border-radius: 15px;
      color: ${Colors.neutral700};

      &:hover,
      &:focus {
        color: ${Colors.neutral700};
        background-color: ${Colors.cream};
      }
      &:focus {
        outline: solid 2px ${Colors.brand};
      }
      outline: solid 2px transparent;
      transition: ${Animation.transitionValue};
    `,
        css `
      /* Hides default icon on details element */
      &::-webkit-details-marker {
        display: none;
      }
      /* Hide default icon from IE. */
      &::before {
        display: none;
      }
    `,
    ],
    summaryInner: css `
    ${Typography.paragraph3Medium};
    line-height: 20px;
    cursor: pointer;
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 20px;
    align-items: center;
    min-height: 50px;
    padding: 10px 15px;
    white-space: nowrap;
    width: 100%;
    transition: ${Animation.transitionValue};
  `,
    caret: css `
    transition: ${Animation.transitionValue};

    [open] & {
      transform: rotate(-180deg);
    }
  `,
    list: css `
    display: grid;
    grid-template-columns: 100%;
    gap: 5px;
    padding: 10px 0;
  `,
    link: css `
    ${Typography.paragraph3Medium};
    display: block;
    border-radius: 3px;
    color: ${Colors.neutral700};
    line-height: 20px;
    padding: 10px 15px;
    text-decoration: none;
    color: ${Colors.neutral700};
    outline: solid 2px transparent;
    transition: ${Animation.transitionValue};

    &:hover,
    &:focus {
      background-color: ${Colors.cream};
      text-decoration: none;
    }
    &:hover {
      outline: solid 2px transparent;
    }
    &:focus {
      outline: solid 2px ${Colors.brand};
    }
  `,
    linkInner: css `
    transform: translateY(1px);
    padding-left: 16px;
  `,
    linkTitle: css `
    display: block;
    text-decoration: none;
    outline: none;
  `,
    linkDescription: css `
    display: block;
    color: ${Colors.neutral700};
    margin-top: 5px;
    font-size: 12px;
    line-height: 15px;
    text-decoration: none;
    outline: none;
  `,
});
const SubmenuLink = (props) => {
    const { getFullyQualifiedURL } = useUniversalNavContext();
    return (isolateComponent(Link, { color: null, css: Styles.link, href: props.href ? getFullyQualifiedURL(props.href) : undefined },
        isolateComponent("div", { css: Styles.linkInner },
            isolateComponent("p", { css: Styles.linkTitle }, props.text),
            props.description && (isolateComponent("p", { css: Styles.linkDescription }, props.description)))));
};
const UniversalSidebarSubmenu = (props) => {
    const linkItems = props.links.map((link) => (isolateComponent("li", { key: link.text },
        isolateComponent(SubmenuLink, Object.assign({}, link)),
        link.submenu && (isolateComponent("ul", null, link.submenu.map((nestedLink) => (isolateComponent("li", { key: nestedLink.text, style: { paddingLeft: '16px' } },
            isolateComponent(SubmenuLink, Object.assign({}, nestedLink))))))))));
    return (isolateComponent("details", null,
        isolateComponent("summary", { css: Styles.summary },
            isolateComponent("div", { css: Styles.summaryInner },
                isolateComponent("span", null, props.text),
                isolateComponent("span", { css: Styles.caret },
                    isolateComponent(Icon, { isBlock: true, name: "arrowSmallDown", size: 24 })))),
        isolateComponent("ul", { css: Styles.list }, linkItems)));
};
export default UniversalSidebarSubmenu;
//# sourceMappingURL=UniversalSidebarSubmenu.js.map
// @zapier/universal-layout@8.3.7 (9c955f548)
